import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { packageService } from '../services/package.service';
import { useAuthStore } from '../stores/auth.store';
import { Package } from '../models/package';
import { PackageType } from '../models/package-type';

/** Package list mixins. */
export function packageListMixins() {
  const authStore = useAuthStore();
  const { currentUser } = storeToRefs(authStore);
  const buyableStatus = computed(() => (currentUser.value.isPfsAdmin ? undefined : true));

  /**
   * Get package list.
   * @param {PackageType[]} [packageTypes] Package types.
   * @returns {Promise<Package[]>}
   */
  function getPackageList(packageTypes) {
    return packageService.getPackages({ packageTypes: packageTypes ?? [], isBuyable: buyableStatus.value });
  }
  return {
    getPackageList,
  };
}
